import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LogoLoader from "../components/loader/LogoLoader";
import { web_url } from "../config/config";

export default function RedirectPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const jobId = queryParams.get("job_id");
    const sourceId = queryParams.get("source_id");
    const sourceSlug = queryParams.get("source_slug");
    const featureId = queryParams.get("feature_id");
    const jobTypeSlug = queryParams.get("job_type_slug");
    const page = queryParams.get("page");
    const feedId = queryParams.get("feed_id");
    const insightId = queryParams.get("insight_id");
    const webPageSlug = queryParams.get("wps") || "/";
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    const targetAlert = queryParams.get("target_alert");

    // job alerts
    const search = queryParams.get("search");
    const locationData = queryParams.get("location");

    if (
      user &&
      token &&
      (jobId || sourceId || feedId || insightId || page == "job-alerts")
    ) {
      if (jobId) {
        navigate(`/${sourceId}/job/${jobId}`);
        return;
      } else if (feedId) {
        navigate(`/home?feed_id=${feedId}`);
        return;
      } else if (insightId) {
        navigate(
          `/${sourceId}/feature/${featureId}/insight-details/${insightId}`
        );
      } else if (page == "job-alerts") {
        if (targetAlert) {
          navigate(
            `/${sourceSlug}/live-job-feed/job-alerts?target_alert=${targetAlert}`
          );
        } else {
          navigate(
            `/jobs/live-job-feed?search=${search}&location=${locationData}`
          );
        }
      } else {
        navigate("/", { replace: true });
      }
    } else if (jobId || feedId || insightId || page == "job-alerts") {
      let redirectUrl = "";
      if (jobId) {
        redirectUrl += `${webPageSlug}/${jobId}`;
      }
      if (insightId) {
        redirectUrl += `insights/insight-details/${insightId}?pi=true`;
      }

      if (feedId) {
        redirectUrl += `?feed_id=${feedId}`;
      }

      if (page == "job-alerts" && targetAlert) {
        redirectUrl += `/${sourceSlug}/live-job-feed/job-alerts?target_alert=${targetAlert}`;
        sessionStorage.setItem("redirect-url", redirectUrl);
        navigate("/", { replace: true });
        return;
      }
      if (page == "job-alerts" && !targetAlert) {
        redirectUrl += `${
          webPageSlug || "/jobs"
        }?search=${search}&location=${locationData}`;
      }

      if (redirectUrl.startsWith("/")) {
        redirectUrl = redirectUrl.substring(1);
      }
      redirectUrl = web_url + redirectUrl;
      window.location.href = redirectUrl;
    } else if (user && token && sourceSlug && jobTypeSlug && targetAlert) {
      navigate(
        `/${sourceSlug}/${jobTypeSlug}/${page}?target_alert=${targetAlert}`
      );
    } else {
      if (targetAlert) {
      }

      // IF missing missing token + user and query Params → redirect to home
      navigate("/", { replace: true });
    }
  }, []);

  return (
    <>
      <LogoLoader />
    </>
  );
}
